import ActionBarGrammar from "@/components/exercises/grammar/Desktop/v3/ActionBar";
import ActionBar from "@/components/v3/exercises/ActionBar";
import ExerciseBadge, {
  ExerciseType,
} from "@/components/v3/exercises/ExerciseBadge";
import { ExerciseTODO, NavigationState } from "@/types";
import { cn } from "@edusogno/lib/utils";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/components/ui/Avatar.tsx";

const STORAGE_ROUTE = import.meta.env.EDS_STORAGE_URL;

type Props = {
  type?: ExerciseType | string;
  title: string;
  audioSrc?: string;
  onClose?: () => void;
  exercise?: ExerciseTODO;
  isCorrection?: boolean;
  onViewEssayByTutor?: () => void;
  isGrammar?: boolean;
  isResult?: boolean;
  timer?: number;
  onSubmit?: () => void;
  date?: string;
  time?: string;
};

const LayoutHeader = ({
  type = ExerciseType.LISTENING,
  title,
  audioSrc,
  onClose,
  isCorrection,
  onViewEssayByTutor,
  onSubmit,
  isGrammar,
  timer,
  isResult,
  exercise,
  date,
  time,
}: Props) => {
  const location = useLocation();
  const state = location.state as NavigationState;
  const { isCR, tutorPic, tutorName, tutorSurname } = state || {};

  return (
    <div
      className={cn(
        "relative until-lg:mt-4 flex flex-col gap-6 xl:flex-row justify-start lg:items-center lg:justify-between lg:gap-4",
        {
          "flex-col-reverse": isCR,
        },
      )}
    >
      <div
        className={cn(
          "flex w-full flex-col lg:flex-row justify-start lg:items-center gap-4 until-lg:mt-10 xl:flex-[1_1_60%] xl:w-[60%]",
          {
            "until-xl:flex-col until-xl:items-start until-xl:[&>p]:text-xs until-xl:gap-2 pt-4":
              isResult,
            "flex-row items-center until-lg:mt-0": isCR,
          },
        )}
      >
        {isCR ? (
          <>
            <ExerciseBadge type={type as ExerciseType} />

            <p className="text-xs font-normal text-white">
              {dayjs(date).format("DD/MM/YYYY")},&nbsp;{time}
            </p>

            <div className={"flex flex-row items-center gap-3 until-md:hidden"}>
              <Avatar className={"w-12 h-12"}>
                <AvatarImage
                  src={`${STORAGE_ROUTE}/${tutorPic}`}
                  className={"object-cover"}
                />

                <AvatarFallback>
                  {(tutorName?.charAt(0) || "") +
                    (tutorSurname?.charAt(0) || "")}
                </AvatarFallback>
              </Avatar>

              <p className="lg:block text-xs font-medium w-full text-center text-white">
                {tutorName}
              </p>
            </div>
          </>
        ) : (
          <div className={cn("flex flex-col justify-start items-start gap-1")}>
            <ExerciseBadge type={type as ExerciseType} />
            
            <p className="text-xl font-semibold text-white">{title}</p>
          </div>
        )}
      </div>

      {isGrammar ? (
        <ActionBarGrammar
          type={type}
          timer={timer}
          onClose={onClose}
          isResult={isResult}
        />
      ) : (
        <div className="w-full xl:flex-[1_1_40%]">
          <ActionBar
            src={audioSrc}
            type={type}
            onClose={onClose}
            exercise={exercise}
            onSubmit={onSubmit}
            isCorrection={isCorrection}
            onViewEssayByTutor={onViewEssayByTutor}
          />
        </div>
      )}
    </div>
  );
};
export default LayoutHeader;
